module.exports = __webpack_public_path__ + "img/hr-assembling-machine-2.7b25b7d1.png";